<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card flat class="mx-auto" max-width="344">
          <v-card-text>
            <p v-if="isSelfSurvey" class="title text-center font-weight-bold">
              Your responses have been submitted, thank you for your time.
            </p>
            <div v-else>
              <p class="title text-center">
                <strong>
                  Your responses have been submitted,
                </strong>
                we appreciate your feedback about <strong class="primary--text">{{ params.EvaluateeFullName }}</strong>.
              </p>
            </div>
          </v-card-text>
          <v-card-text>
            <template v-if="isSelfSurvey">
                <p class="text-center">
                    Please now nominate at least 5 peers to provide feedback on you in the
                    <a target="_blank" :href="params.Inportal180InviteFeedbackUrl">Invite for 180 Feedback </a> page.
                </p>
              <p class="text-center">
                To provide 180 feedback to your peers, go to the <a target="_blank" :href="params.TodoListUrl">My To-Do - 180 Feedback</a> tab to access invitations, or
                the <a target="_blank" :href="params.Inportal180GiveFeedbackUrl">180 Feedback - Give Feedback</a> tab to voluntarily provide feedback.
              </p>
            </template>
            <p v-else class="text-center">
              You can now close your browser page or return to your <a target="_blank" :href="params.TodoListUrl">My To-Do - 180 Feedback</a> tab to complete more
              invitations, or the <a target="_blank" :href="params.Inportal180GiveFeedbackUrl">180 Feedback - Give Feedback</a> tab to voluntarily provide feedback to any of your
              peers.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <div class="ma-8">
        <img text-center alt="Powered by Resonate" src="@/assets/poweredbyresonate.svg" />
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Outro',

  data() {
    return {};
  },

  computed: {
    ...mapGetters(['currentStep', 'isSelfSurvey']),
    params() {
      return this.$store.state.params;
    },
  },
};
</script>
